export default __webpack_public_path__ + "static/media/em_lsleeve_3.b0b0d637.jpg";